import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
const { delimited, map, option, right } = Parser;
export class Not {
    static of(condition) {
        return new Not(condition);
    }
    _condition;
    constructor(condition) {
        this._condition = condition;
    }
    get condition() {
        return this._condition;
    }
    matches(device) {
        return !this._condition.matches(device);
    }
    equals(value) {
        return value instanceof Not && value._condition.equals(this._condition);
    }
    *iterator() {
        yield* this._condition;
    }
    [Symbol.iterator]() {
        return this.iterator();
    }
    toJSON() {
        return {
            type: "not",
            condition: this._condition.toJSON(),
        };
    }
    toString() {
        return `not (${this._condition})`;
    }
}
(function (Not) {
    function isNot(value) {
        return value instanceof Not;
    }
    Not.isNot = isNot;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-not}
     *
     * @internal
     */
    function parse(parseInParens, featureParser) {
        return map(right(delimited(option(Token.parseWhitespace), Token.parseIdent("not")), parseInParens(featureParser)), Not.of);
    }
    Not.parse = parse;
})(Not || (Not = {}));
//# sourceMappingURL=not.js.map